// src/components/ui/Select.jsx
import React from "react";

export default function Select({ label, value, onChange, options = [], disabled, className = "", ...props }) {
  return (
    <div className="flex flex-col space-y-1">
      {label && <label className="text-sm text-gray-400">{label}</label>}
      <select
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`w-full bg-secondary-800 border border-secondary-700 text-white rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 ${className}`}
        {...props}
      >
        {options.map((opt) => (
          <option
            key={opt.value}
            value={opt.value}
            className={`bg-secondary-900${opt.muted ? " text-gray-500 italic" : ""}`}
          >
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
